import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

/**
 * Modal para elegir imagen de producto entre los candidatos de la busqueda
 * (serper/Bing). Recibe en componentProps.data:
 *   { header, images: [{ url, thumb, w, h }, ...] }
 * y se cierra (dismiss) devolviendo el INDICE (number) de la imagen elegida, o null.
 * Muestra las miniaturas; la descarga a base64 la hace quien lo abre.
 */
@Component({
    selector: 'modal-image-picker',
    template: `
        <ion-header>
            <ion-toolbar color="dark">
                <ion-title [innerHTML]="_header"></ion-title>
                <ion-buttons slot="end">
                    <ion-button [attr.data-id]="'image-picker-close'" [attr.aria-label]="_closeLabel" (click)="OnClose()">
                        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>
        <ion-content color="light">
            <div class="image-picker-grid">
                <div class="image-picker-cell" *ngFor="let _img of _images; let _i = index"
                     [attr.data-id]="'image-picker-cell-' + _i" role="button" tabindex="0"
                     [attr.aria-label]="_header + ' ' + (_i + 1)"
                     (click)="OnPick(_i)" (keydown.enter)="OnKey($event, _i)" (keydown.space)="OnKey($event, _i)">
                    <img [src]="_img.thumb" alt="" loading="lazy" (error)="OnImgError($event, _img)"/>
                </div>
            </div>
            <p class="image-picker-empty" *ngIf="!_images.length">{{ _empty }}</p>
        </ion-content>
    `,
    styles: [`
        .image-picker-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
            gap: 8px;
            padding: 10px;
        }
        .image-picker-cell {
            position: relative;
            aspect-ratio: 1 / 1;
            border: 2px solid transparent;
            border-radius: 6px;
            overflow: hidden;
            cursor: pointer;
            background: #00000010;
        }
        .image-picker-cell:hover { border-color: var(--ion-color-success, #2dd36f); }
        .image-picker-cell img { width: 100%; height: 100%; object-fit: cover; display: block; }
        .image-picker-empty { text-align: center; padding: 24px; opacity: .7; }
    `]
})
export class imagePickerModal implements OnInit {
    constructor(private modalCtrl: ModalController, private params: NavParams) {}

    public _header: string = '';
    public _empty: string = '';
    public _images: any[] = [];
    // Nombre accesible del boton de cierre (solo icono): lo pasa quien abre el
    // modal ya traducido; fallback a 'Cerrar' si no llega.
    public _closeLabel: string = 'Cerrar';

    ngOnInit(){
        const _data = this.params.get('data') || {};
        this._header = _data.header || '';
        this._empty  = _data.empty || '';
        this._images = Array.isArray(_data.images) ? _data.images : [];
        if (_data.closeLabel){
            this._closeLabel = _data.closeLabel;
        }
    }

    OnPick(_index){
        this.modalCtrl.dismiss(_index);
    }

    /** Teclado (Enter/Espacio): evita el scroll por defecto del Espacio y elige. */
    OnKey(_event, _index){
        if (_event){
            _event.preventDefault();
        }
        this.OnPick(_index);
    }

    OnClose(){
        this.modalCtrl.dismiss(null);
    }

    /** Si la miniatura no carga, probamos la url grande; si tampoco, ocultamos. */
    OnImgError(_event, _img){
        const _el = _event && _event.target;
        if (!_el){
            return;
        }
        if (_img && _img.url && _el.src !== _img.url){
            _el.src = _img.url;
            return;
        }
        const _cell = _el.parentElement;
        if (_cell){
            _cell.style.display = 'none';
        }
    }
}
